import type { Price } from '@fourthwall/services/dist/models/common'
import type { ReactNode } from 'react'

export const isPrice = (value: Price | ReactNode): value is Price => {
  return !!value && typeof value === 'object' && 'currency' in value
}
